const UserRegistration = () => import('./User/UserRegistration.vue');

export default [
    {
        path: '/home/registerSetup/:hash',
        component: UserRegistration,
        props: true
    }
]
